/* tslint:disable */
/* eslint-disable */
/* @relayHash 2a18d69bf84549997175024cea3f464b */

import { ConcreteRequest } from "relay-runtime";
export type ResetPassword_FinaliseMutationVariables = {
    token: string;
    password: string;
};
export type ResetPassword_FinaliseMutationResponse = {
    readonly resetPassword: {
        readonly token: string;
    } | null;
};
export type ResetPassword_FinaliseMutation = {
    readonly response: ResetPassword_FinaliseMutationResponse;
    readonly variables: ResetPassword_FinaliseMutationVariables;
};



/*
mutation ResetPassword_FinaliseMutation(
  $token: String!
  $password: String!
) {
  resetPassword(input: {token: $token, password: $password}) {
    token
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "token",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "password",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "resetPassword",
            "storageKey": null,
            "args": [
                {
                    "kind": "ObjectValue",
                    "name": "input",
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "password",
                            "variableName": "password"
                        },
                        {
                            "kind": "Variable",
                            "name": "token",
                            "variableName": "token"
                        }
                    ]
                }
            ],
            "concreteType": "AuthToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "token",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ResetPassword_FinaliseMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "ResetPassword_FinaliseMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "ResetPassword_FinaliseMutation",
            "id": null,
            "text": "mutation ResetPassword_FinaliseMutation(\n  $token: String!\n  $password: String!\n) {\n  resetPassword(input: {token: $token, password: $password}) {\n    token\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '5f84ea74440a665ffcdee1f74e4990eb';
export default node;
